/**
 * TestimonialSlider.jsx — Auto-sliding testimonials (rankingCoach stijl)
 */
import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight, Star } from 'lucide-react';

const TESTIMONIALS = [
  {
    name: 'Martijn de Vries',
    company: 'De Vries Installatie',
    role: 'Eigenaar',
    text: 'Via IMPERIA AI Radar zag ik direct dat mijn Google Bedrijfsprofiel niet compleet was. Na het volgen van de instructies zijn we in 3 weken van positie 18 naar positie 4 gegaan in Google Maps.',
    rating: 5,
    result: '+340% meer websitebezoekers',
  },
  {
    name: 'Sandra Kuiper',
    company: 'Kuiper Fysiotherapie',
    role: 'Praktijkhouder',
    text: 'Ik had geen idee dat mijn website zulke basisfouten had. De groeiscan toonde alles duidelijk. Na 2 maanden zijn mijn nieuwe afspraken met 60% gestegen via online kanalen.',
    rating: 5,
    result: '+60% nieuwe afspraken',
  },
  {
    name: 'Thomas Bakker',
    company: 'Bakker & Zonen BV',
    role: 'Directeur',
    text: 'Het dashboard geeft mij precies inzicht in wat er online gebeurt met mijn bedrijf. De AI aanbevelingen zijn heel concreet en uitvoerbaar. Geweldige tool voor elk MKB-bedrijf.',
    rating: 5,
    result: '+127% organisch verkeer',
  },
  {
    name: 'Fatima El Amrani',
    company: 'Schoonheidssalon Lumière',
    role: 'Eigenaar',
    text: 'De reputatiemodule heeft mij geholpen om veel meer reviews te verzamelen. Mijn gemiddelde score is van 3.8 naar 4.7 gegaan. Klanten vinden mij nu veel makkelijker via Google.',
    rating: 5,
    result: '4.7★ gemiddelde beoordeling',
  },
  {
    name: 'Peter van Dijk',
    company: 'Van Dijk Advocaten',
    role: 'Partner',
    text: 'Als advocatenkantoor zijn we afhankelijk van lokale vindbaarheid. Na 6 maanden IMPERIA AI Radar zijn we top 3 in Google voor alle relevante zoektermen in onze regio.',
    rating: 5,
    result: 'Top 3 Google voor 12 zoekwoorden',
  },
];

export default function TestimonialSlider({ dark = false }) {
  const [active, setActive] = useState(0);
  const [animating, setAnimating] = useState(false);

  useEffect(() => {
    const t = setInterval(() => goNext(), 5000);
    return () => clearInterval(t);
  }, [active]);

  const go = (idx) => {
    if (animating) return;
    setAnimating(true);
    setTimeout(() => { setActive(idx); setAnimating(false); }, 300);
  };
  const goNext = () => go((active + 1) % TESTIMONIALS.length);
  const goPrev = () => go((active - 1 + TESTIMONIALS.length) % TESTIMONIALS.length);

  const t = TESTIMONIALS[active];
  const bg = dark ? 'bg-white/5 border-white/10' : 'bg-white border-gray-100';
  const textPrimary = dark ? 'text-white' : 'text-[#0f172a]';
  const textSec = dark ? 'text-white/60' : 'text-[#64748b]';

  return (
    <div className="max-w-3xl mx-auto">
      {/* Stars */}
      <div className="flex justify-center gap-1 mb-5">
        {[...Array(t.rating)].map((_, i) => (
          <Star key={i} className="w-5 h-5 text-[#D4A017] fill-[#D4A017]" />
        ))}
      </div>

      {/* Quote */}
      <div className={`rounded-2xl border p-8 text-center mb-6 transition-opacity duration-300 ${bg} ${animating ? 'opacity-0' : 'opacity-100'}`}>
        <div className="text-4xl text-[#D4A017] mb-4 font-serif leading-none">"</div>
        <p className={`text-base md:text-lg leading-relaxed mb-6 ${textPrimary}`}>{t.text}</p>
        <div className="inline-flex items-center gap-2 bg-[#D4A017]/10 border border-[#D4A017]/20 rounded-full px-4 py-2">
          <span className="text-[#D4A017] font-bold text-sm">📈 {t.result}</span>
        </div>
      </div>

      {/* Author */}
      <div className={`text-center mb-6 transition-opacity duration-300 ${animating ? 'opacity-0' : 'opacity-100'}`}>
        <p className={`font-bold ${textPrimary}`}>{t.name}</p>
        <p className={`text-sm ${textSec}`}>{t.role} · {t.company}</p>
      </div>

      {/* Controls */}
      <div className="flex items-center justify-center gap-4">
        <button onClick={goPrev}
          className={`w-10 h-10 rounded-full border flex items-center justify-center transition-all hover:scale-110 ${dark ? 'border-white/20 text-white/60 hover:border-[#D4A017] hover:text-[#D4A017]' : 'border-gray-200 text-[#64748b] hover:border-[#D4A017] hover:text-[#D4A017]'}`}>
          <ChevronLeft size={18} />
        </button>
        <div className="flex gap-2">
          {TESTIMONIALS.map((_, i) => (
            <button key={i} onClick={() => go(i)}
              className={`w-2 h-2 rounded-full transition-all duration-300 ${i === active ? 'bg-[#D4A017] w-6' : dark ? 'bg-white/20' : 'bg-gray-200'}`} />
          ))}
        </div>
        <button onClick={goNext}
          className={`w-10 h-10 rounded-full border flex items-center justify-center transition-all hover:scale-110 ${dark ? 'border-white/20 text-white/60 hover:border-[#D4A017] hover:text-[#D4A017]' : 'border-gray-200 text-[#64748b] hover:border-[#D4A017] hover:text-[#D4A017]'}`}>
          <ChevronRight size={18} />
        </button>
      </div>
    </div>
  );
}
